import * as action_types from './action_types';

export const getDomains = (data) => {
    return {
        type: action_types.GET_DOMAIN,
        data: data
    }
};


// WEBPACK FOOTER //
// ./src/actions/DomainActions.js